const capitalise = (word) => {
    return `${word[0].toUpperCase()}${word.substring(1, word.length).toLowerCase()}`
}

const string = {capitalise}

export default string